import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/VisionStrategy/components/SectionDigitisation/SectionDigitisation.module.scss';

const cn = classNames.bind(styles);

const SectionDigitisation = (): ReactElement => {
  return (
    <section className={cn('digitisation')}>
      <div className={cn('container')}>

        <div className={cn('digitisation__image-container')}>
          <picture>
            <source
              srcSet="
                /images/pages/Company/VisionAndStrategy/users.webp 1x,
                /images/pages/Company/VisionAndStrategy/users@2x.webp 2x
              "
              sizes='100vw'
            />
            <img
              className={cn('digitisation__image')}
              src='/images/pages/Company/VisionAndStrategy/users.webp'
              alt='Digitization'
            />
          </picture>
        </div>

        <div className={cn('digitisation__description')}>
          <p className={cn('digitisation__paragraph')}>
            To understand the philosophy behind how a wider vision grew
            from this beginning one needs to know that DFA was born from DP
            World and that DP World was born from the cultural background
            of Dubai as an entrepot. As barriers have progressively risen
            to world trade in the last ten years, DP World sees the digital
            revolution as an alternative engine to create growth.
          </p>
        </div>

        <div className={cn('digitisation__svg-container')}>
          <img
            className={cn('digitisation__svg')}
            src='/images/pages/Company/VisionAndStrategy/laptop.svg'
            alt='Laptop'
          />
        </div>

      </div>
    </section>
  );
};

export default SectionDigitisation;